import { useState } from 'react';
import { TypedLines } from './onboarding-beats-shared';
import type { BeatContext, BeatPayload } from './onboarding-beats-shared';

const INTRO = [
  "I think we have shown you that AI applied to your data can lead to great things.",
];

interface Chip {
  cmd: string;
  description: string;
  prompt: string;
}

const CHIPS: Chip[] = [
  { cmd: '/schedule',  description: 'Your day and the next 90 days at a glance',    prompt: '/schedule' },
  { cmd: '/circle',    description: 'Your inner circle — who\'s closest, who\'s quiet', prompt: '/circle' },
  { cmd: '/travel',    description: 'Your travel report — 12 months of trips',       prompt: '/travel' },
  { cmd: '/food',      description: 'Where you eat — your reservations report',      prompt: '/food' },
  { cmd: '/social',    description: 'How you show up on the web',                    prompt: '/social' },
  { cmd: '/inbox',     description: 'What needs your attention right now',           prompt: '/inbox' },
  { cmd: '/profile',   description: 'Your archetype card',                           prompt: '/profile' },
];

export function OnboardingCommandsBeat({
  payload: _payload,
  ctx,
}: {
  payload: BeatPayload;
  ctx: BeatContext;
}) {
  const [introDone, setIntroDone] = useState(!ctx.isCurrent);

  return (
    <>
      <TypedLines
        active={ctx.isCurrent}
        className="obr-assess-intro"
        lines={INTRO}
        onComplete={() => setIntroDone(true)}
      />
      {introDone && (
        <div className="ocb-card opc-card obr-fade">
          <div className="ocb-next-steps-label">Next steps</div>
          <div className="ocb-chip-list">
            {CHIPS.map((chip) => (
              <button
                key={chip.cmd}
                type="button"
                className="ocb-chip-row"
                onClick={() => {
                  if (ctx.runCommand) {
                    ctx.runCommand(chip.prompt);
                  } else {
                    ctx.runPrompt(chip.prompt);
                  }
                }}
              >
                <span className="ocb-chip-cmd">{chip.cmd}</span>
                <span className="ocb-chip-desc">{chip.description}</span>
              </button>
            ))}
          </div>
          <p className="ocb-tip">Type <kbd>/</kbd> anytime to see every command.</p>
        </div>
      )}
      {introDone && ctx.isCurrent && (
        <button
          type="button"
          className="oa-skip-link"
          onClick={() => ctx.onComplete()}
        >
          Ask me anything
        </button>
      )}
    </>
  );
}
